import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {RolesLabelEnum} from './role.model';
import {URL_BASE} from '../../core/constants';
import {HttpClient} from '@angular/common/http';
import {HttpUtils} from '../../shared/http-utils';
import {map} from 'rxjs/operators';
import {UserInfo} from './user-info.model';
import {SearchObjectResult} from '../../shared/search-object-result.model';
import {UserSearchCriteria} from '../../shared/user-search-criteria';

@Injectable()
export class RolesLabelService {

  private ROLES_URI = 'api/roles';

  constructor(private http: HttpClient) {
  }

  public getAllUsersByRole(role: RolesLabelEnum): Observable<UserInfo[]> {
    const headers = HttpUtils.createHeaders();
    const url     = `${URL_BASE}/${this.ROLES_URI}/labels/${role}/users`;
    return this.http.get(url, { headers })
      .pipe(
        map((users: any[]) => users.map(user => UserInfo.fromDto(user)))
      );
  }

  public searchUsersByRole(role: RolesLabelEnum, page: number, pageSize: number, filters: UserSearchCriteria = new UserSearchCriteria()): Observable<SearchObjectResult<UserInfo>> {
    const headers = HttpUtils.createHeaders();
    const params = filters.toQueryParams(page, pageSize);

    const url = `${URL_BASE}/${this.ROLES_URI}/labels/${role}/users/search`;
    return this.http.get(url, {headers, params})
      .pipe(
        map(result => SearchObjectResult.fromDto(result, UserInfo.fromDto))
      );
  }

  public addRoleToUsers(role: RolesLabelEnum, users: UserInfo[]): Observable<void> {
    const headers = HttpUtils.createHeaders();
    const url     = `${URL_BASE}/${this.ROLES_URI}/labels/${role}/users`;
    const payload = { users: users.map(user => user.id)}
    return this.http.post<void>(url, payload, { headers });
  }

  public removeRoleOfUser(role: RolesLabelEnum, userId: string): Observable<boolean> {
    const headers = HttpUtils.createHeaders();
    const url     = `${URL_BASE}/${this.ROLES_URI}/labels/${role}/users/${userId}`;

    return this.http.delete<boolean>(url, { headers });
  }
}
